import Vue from "vue";

import App from "@/AppMenu.vue";
import router from "@/router/menu.js";
import store from "@/store/menu.js";
import Axios from 'axios';
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueCurrencyFilter from 'vue-currency-filter';
import VueTheMask from 'vue-the-mask'

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue2-dropzone/dist/vue2Dropzone.min.css"

// import moment from 'moment'
const moment = require('moment-timezone');

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueCurrencyFilter, {
	symbol: '$',
	thousandsSeparator: ',',
	fractionCount: 2,
	fractionSeparator: '.',
	symbolPosition: 'front',
	symbolSpacing: false,
});
Vue.use(VueTheMask)
Vue.filter('phone', function (phone) {
    return phone===null?"":phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

Vue.prototype.$Permission = Object.freeze({"Root" : 1, "SysAdmin" : 11, "OrgAdmin" : 21, "LocAdmin" : 31, "NoAccess" : 10000})

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;

const API_URL = process.env.NODE_ENV === 'production' ? '/api/r' : (process.env.VUE_APP_API_URL || '/api/r')

Vue.prototype.$http.defaults.baseURL = API_URL
Vue.prototype.$http.defaults.headers.post['Accept'] = 'application/json';
Vue.prototype.$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.moment = moment
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
